export default {
  setTestimonies(state, payload) {
    state.testimonies = payload;
  },
};
